import { createSlice } from '@reduxjs/toolkit';

import { ICustomer, ICustomerResponse } from '@/types/customers';

export interface ICustomersReducer {
  customer: ICustomer | null;
  customers: ICustomerResponse;
}

const initialState = {
  customer: null,
  customers: {
    items: [],
    pagination: {
      page: 1,
      limit: 5,
      totalPages: 1,
    },
  },
} as unknown as ICustomersReducer;

export const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setCustomer: (state, action) => {
      state.customer = action.payload;
    },
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
    updateCustomerInList: (state, action) => {
      const newCustomer = action.payload;
      state.customers.items = state.customers.items.map(customer =>
        customer.referenceId === newCustomer.referenceId
          ? newCustomer
          : customer
      );
    },
  },
});

export const { setCustomer, setCustomers, updateCustomerInList } = customersSlice.actions;
